import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { pagedQueryFn } from "../../../shared/api/paged-query-fn";

interface IWorkPlacesDto {
  id: string;
  importId: string | null;
  name: string;
  farmId: string;
  deletedAt: number | null;
  isDeleted: boolean;
  createdAt: number | null;
  updatedAt: number | null;
  createdByUserId: number | null;
  updatedByUserId: number | null;
}

export const workPlacesApi = createApi({
  reducerPath: "workPlacesApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchWorkPlaces: builder.query<IWorkPlacesDto[], void>({
      queryFn: pagedQueryFn<IWorkPlacesDto, IWorkPlacesDto[]>(
        { url: "WorkPlacesV2" },
        (dtos) => dtos
      ),
    }),
  }),
});

export const { useFetchWorkPlacesQuery } = workPlacesApi;
